<template>
  <accordion-simple-item title="Datenbank" :flex="true" v-if="userData?.isSuperAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="tableSearch" type="text" placeholder="Tabelle suchen..." class="p-2 w-full my-2"
               data-ui="search-ekb-input"></TRInput>
      <button @click="navigateTo(`/administration/${accordionIndex}/createSQLSkript`)"
              class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              data-ui="create-new-EKB">
        Neue Abfrage erstellen
      </button>
      <div class=" overflow-auto " data-ui="ekb-list">
        <div v-for="(table, index) in filteredTables" :key="table" :data-ui="'navigate-to'+ table"
             @click="navigateTo(`/administration/${accordionIndex}/superAdmin`, { tableName: table })"
             class="w-full p-1  flex my-2"
             :class="{ 'bg-trader-blue text-white': table === selectedTable, 'bg-trader-dark-gray': table !== selectedTable }">
          <span class=" pl-4 w-full cursor-pointer"> {{ table }} </span>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>


<script setup lang="ts">

import router from "@/router";
import {computed, onMounted, ref, watch} from "vue"
import {useRoute} from 'vue-router';
import {query} from "@/graphql";
import { useStore } from "vuex"; // <-- DIESER IMPORT FEHLT
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import TRInput from "@/components/Base/TRInput.vue";

const tables = ref<string[]>([]);
const tableSearch = ref("");
const selectedTable = ref(null);
const store = useStore();
const userData = computed(() => store.state.user.userData);
const route = useRoute();

const filteredTables = computed(() => {
  if (!tableSearch.value) {
    return tables.value;
  }
  return tables.value.filter(table =>
    table.toLowerCase().includes(tableSearch.value.toLowerCase())
  );
});

const props = defineProps({
  accordionIndex: {
    type: Number,
    default: () => {
    }
  },
});

async function getTables() {

  const [data,error] = await query.getTablesFromDatabase()
  if (error) {
    console.error("Error fetching tables:", error);
    return;
  }
  tables.value = data;
}

function navigateTo(route, params = {}) {
  let path = route;
  if (Object.keys(params).length) {
    const paramParts = Object.keys(params).map(key => params[key]);
    path += '/' + paramParts.join('/');
  }
  router.push(path);
}
onMounted(async () => {
 await getTables();
 //  selectedTable.value  == url param
  selectedTable.value = route.params.tableName;
})


watch(() => route.params.tableName, (newVal) => {
  selectedTable.value = newVal;
});

/*
created() {
    this.teamId =  this.$route.params.teamId
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.teamId = params.teamId;
      },
    },
  },
 */



</script>